import { render, staticRenderFns } from "./NewsCard.vue?vue&type=template&id=1208f4aa&scoped=true"
import script from "./NewsCard.vue?vue&type=script&lang=js"
export * from "./NewsCard.vue?vue&type=script&lang=js"
import style0 from "./NewsCard.vue?vue&type=style&index=0&id=1208f4aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1208f4aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1208f4aa')) {
      api.createRecord('1208f4aa', component.options)
    } else {
      api.reload('1208f4aa', component.options)
    }
    module.hot.accept("./NewsCard.vue?vue&type=template&id=1208f4aa&scoped=true", function () {
      api.rerender('1208f4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/international/components/NewsCard.vue"
export default component.exports